import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { LoginService } from '../services/Login.service';
import jwt_decode from 'jwt-decode';
import { JwtData } from '../interfaces/jwt-data';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
@Directive({
  selector: '[isAuthorized]',
})
export class IsAuthorizedDirective implements OnInit {
  private _roleName = '';
  private _userRole = '';

  @Input('isAuthorized')
  public set roleName(roleName: string) {
    this._roleName = roleName;
    const token = localStorage.getItem('token');
    const tokenData = new JwtData(jwt_decode(token!, { header: false }));
    this._userRole = tokenData.role;
    const isValid = this.loginService.validRole(tokenData.role, roleName);
    if (!isValid) {
      this.container.clear();
    }
  }

  onLoad = true;
  constructor(
    element: TemplateRef<any>,
    private container: ViewContainerRef,
    private loginService: LoginService,
    private router: Router
  ) {
    
    container.clear();
    loginService.loginStatus$.subscribe((result) => {
      if (result === false) {
        
        container.clear();
      } else {
        if (!loginService.validRole(this._userRole, this._roleName)) {
          
          container.clear();
          return;
        }
        container.clear();
        container.createEmbeddedView(element);
      }
    });
  }
  ngOnInit(): void {

  }


}
